import TerritoryController from "@/api/controller/territoryController";
import { createApiGetAsyncThunk } from "@/store/utils";

export const fetchRegions = createApiGetAsyncThunk(
  "region/fetchRegions",
  TerritoryController.getRegions,
  (state) => state.region.regions,
);
